import makeFlex from "./flex";
var Flex = makeFlex("div");
export default Flex;
